module.exports = __webpack_public_path__ + "d6413ba1/img/settings-ico.a214628d.svg";